import patchRequest from '../../patchRequest';

// /**
//  * Update UpdateSchedule into PRISM db.
//  * @param {ObjectId} LogId - ""
//  * @param {string} DeploymentMode - "Yes/No"
//  * @param {date} StartTime
//  * @param {date} EndTime
//  * @param {string} CreatedBy - ashwini
//  * @param {date} CreatedDate
//  * @param {string} ReleaseNote - 3fa85f64-5717-4562-b3fc-2c963f66afa6com
//  * @param {string} Reason - 3fa85f64-5717-4562-b3fc-2c963f66afa6com
//  * @returns {object} { Success: true, Error: null }
//  */

function postUpdateSchedule(body) {
  const endpoint = '/deployment/update-schedule';
  return new Promise((resolve, reject) => {
    patchRequest(endpoint, body, 'Update Deployment schedule')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postUpdateSchedule;
